import React, {FC} from "react"

import Flex from "@irati/ui/src/Flex"
import {H5, Label} from "@irati/ui/src/Typography"
import {formatFromTimeToHoursAndMinutes, getImageUrlByWidth, liveVideoDate} from "@irati/wellness/utils"

import {RouterLink} from "@irati/ui/src/Link"
import {WellnessMedia, WellnessMediaType} from "@irati/types"
import {MediaThumbnail, RelatedMediaWrapper} from "./styled"

interface Props {
  media: WellnessMedia
}

const RelatedMedia: FC<Props> = ({media}) => {
  const {title, duration, thumbnail, uuid, type, liveVideoStartTime, liveVideoEndTime} = media

  return (
    <RouterLink to={`/details/${uuid}`} plain>
      <RelatedMediaWrapper marginTop={2} alignItems="center">
        <MediaThumbnail src={getImageUrlByWidth(thumbnail, 240)} />

        <Flex direction="column" paddingLeft={2}>
          <H5 marginBottom>{title}</H5>
          <Label>
            {type === WellnessMediaType.LiveVideo
              ? liveVideoDate(liveVideoStartTime, liveVideoEndTime, {displayShortMonth: true})
              : formatFromTimeToHoursAndMinutes(duration)}
          </Label>
        </Flex>
      </RelatedMediaWrapper>
    </RouterLink>
  )
}

export default RelatedMedia
